module.exports = __webpack_public_path__ + "img/uncomplatenew.fa2e5ae9.svg";